export const NO_DATA_AVAILABLE = 'No Data Available';
export const SELECT_TYPE_MESSAGE = 'Select type in the above menu to get started';
export const DataTypeDefaultOption = { value: 'Select', label: 'Select' };
